<template>
 <!-- Modal -->
  <div class="content-box-gray card modal fade" id="display-habit-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
<!-- <div v-if="milestoneAchieved" class="overlay"> -->
    <div v-if="milestoneAchieved" id="yayOverlay" class="overlay" >
        <h5>Yay, you've achieved a Milestone: {{ attempt_count }} consecutive days!</h5>
        <img src="/images/yays/rugby-yay.gif" >
    </div>
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header title text-center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
         <h6 class="modal-title" id="myModalLabel" v-html="'Record Your Performance:&nbsp;on your <em><u>' + currenthabitdata.name + '</em> Action-Habit</u>'" ></h6>
        </div>
        <div class=" content modal-body">
          <div class="embed-responsive"> <!-- embed-responsive-16by9 -->
                <!-- <em>Habit Name:</em> {{currenthabitdata.name}}<br/> -->
                <p style="color:brown;text-align: center;">Purpose: <i>{{currenthabitdata.description}}</i></p>
               <!-- <em>Check Frequency:</em> {{currenthabitdata.frequency}}</p> -->
                <div  class="card" v-if="currenthabitdata">
                    <h5  class="header-box-msg  text-center">Click those you've done: (Remaining: {{ remainingComponents.length }})</h5>
                    <div v-for="component in currenthabitdata.components" :key="component.id">
                        <button :id="component.id" class="btn btn-sm btn-primary tracker-btn" style="margin:auto;"
                            @click="setupDoneComponent(component.id)" ><b>{{component.name}}:</b> ({{component.description}})
                        </button>
                        <div hidden :id="'div'+component.id" ><small><span style="color:#55060e;">Recorded: </span><b>{{component.name}}:</b> ({{component.description}}, <em>{{component.weight}} points</em>.)</small></div>
                    </div>
                </div>
                <div>
                <button :hidden="savedPerformance" :disabled="remainingComponents.length>0" @click="savePerformance()" class="btn btn-sm btn-warning float-right">Record Your Performance &nbsp;<i class="fas fa-save"></i></button>
                <button @click="cancel()" class="btn btn-sm btn-warning float-right">Close &nbsp;<i class="fas fa-times"></i></button>
                <!-- <button @click="milestoneAchieved=true" class="btn btn-sm btn-warning float-right">Test Yay Display &nbsp;<i class="fas fa-times"></i></button> -->
                <span style="color:#55060e;font-size:x-small;" v-if="message"><br/>{{ message }}</span>
                </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../event-bus';
import axios from 'axios';
import Errors from '../../partials/Errors.vue';
import Swal from 'sweetalert2';
// var _ = require('lodash');

export default {
    components: { Errors,
    },
    name: "TrackActionHabitModal",
    data() {
        return {
            currenthabitdata:[],
            remainingComponents:[],

            actionhabitcomponents: '',
            savedPerformance: false,
            milestoneAchieved : false,
            attempt_count: 0,
            message:''
        }
    },
    props: {
    },
    mounted() {
        EventBus.$on('displayActionHabitTrackerModal', (data) => {
            console.log("In HabitTrackerModal: "+ data.habitdata);
            this.currenthabitdata = data.habitdata;
            // console.log(this.currenthabitdata);
            this.actionhabitcomponents = this.currenthabitdata.components;
            this.remainingComponents = Array.from(this.currenthabitdata.components);
             this.userdata = data.userdata;
            $('div#display-habit-modal').modal('show');
        });
    },
    methods: {
        cancel() {
            this.milestoneAchieved = false; //shut down redisplay of yay (if triggered) and if this modal is re-displayed.
            this.message = '';
            this.currenthabitdata = '';
            this.actionhabitcomponents = '';
            this.remainingComponents = '';
            this.savedPerformance= false;
            $('div#display-habit-modal').modal('hide');
        },
         informChart(newdata) {
             this.$root.$emit('updateChart', newdata);
        },
        disableClickedButton(compid) {
            document.getElementById(compid).hidden = true;
            document.getElementById('div'+compid).hidden = false;
        },
        strikeThroughComponent(component_id) {
            const thisEl = document.getElementById(component_id);
            thisEl.style.textDecoration = 'line-through';
            thisEl.disabled = true;
            // console.log('Strikethrough done. pls check');
        },
        trackRemainingComponents(componentid) {
            this.remainingComponents = [...this.remainingComponents].filter(function (component){
                    return component.id != componentid;
                });
        },

        setupDoneComponent(compid) {
            this.strikeThroughComponent(compid);
            this.trackRemainingComponents(compid);
        },

        disableRecordPerfButton(){
            this.savedPerformance = true; //hides the button
        },
        savePerformance() {

            if(this.remainingComponents.length==0) {

            let incomingdata = '';
                console.error("Saving Done on action_habit_id: user_id: " + this.userdata.id + ", action_habitID: " + this.currenthabitdata.id);
                axios.post('/actionhabits/tracking/update', {
                    user_id:this.userdata.id,
                    action_habit_id: this.currenthabitdata.id,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.attempt_count = res.data.attempt_count;
                    this.milestoneAchieved = (res.data.attempt_count % 10 === 0);
                    this.attempt_count = res.data.attempt_count;
                    this.failure = false;

                })
                .catch(err => {
                    this.loading = false;
                    this.failure = true;
                    this.success = false;
                })
                .finally(() => {
                        //  console.error('In delete finally.....');
                        // console.error(incomingdata);
                        this.disableRecordPerfButton();
                        // this.informChart();
                        this.$forceUpdate();
                });
            } else {
                console.error ("Check... this button should not have been clickable")

            }
        },
        startTracking(habit_id) {
        },



        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow: wrap;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
     background:#1a794b;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}


.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: fadeOut 5s forwards;
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

#yayOverlay {
  width: 40vw;
  height: 40vh;
  border: 2px solid #000;
  border-radius: 4px;
  box-shadow: #555 4px 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

}

#yayOverlay.h5 {
  max-width: 100%;
  margin: 0;
  padding: 10px;
  word-wrap: break-word;
}
#yayOverlay.img {
  max-width: 100%;
  max-height: 80%;
  object-fit: contain;
}

@media (max-width: 768px) {
 #yayOverlay.card {
    width: 80vw;
    height: 60vh;
    /* Adjust dimensions and other styles for mobile */
  }
#yayOverlay.img {
  width: 80%;
  object-fit: contain;
}

}


</style>
